import React from 'react';
import './dadosBancarios.scss';

//Componentes
import Breadcrumbs from '../../components/breadcrumbs';
import NavigationButtons from '../../components/navigationButtons';
import Typeaheader from '../../components/typeahead';
import Field from '../../components/field';
import Dropdown from '../../components/dropdown';
import CheckObligation from '../../components/checkObligation'

class DadosBancarios extends React.Component {

  componentWillMount() {
    this.formFields = []

    let { listDadosBancoAction, listTipoContaAction } = this.props;
    listDadosBancoAction();
    listTipoContaAction();
  }

  render() {

    let {
        typeaheaderBancoList,
        dropdownTipoContaList,
        loadingTipoConta
    } = this.props.dadosBancarios;

    let {
        dadosBancarios_Banco,
        dadosBancarios_TipoConta,
        dadosBancarios_Agencia,
        dadosBancarios_Conta,
    } = this.props.dadosBancarios.formDadosBancarios;

    let {
        loadingDadosBancarios,
        handleChangeDadosBanco,
        changeDadosIniciaisDadosBancariosValueForm,
        handleChangeDadosTipoConta
    } = this.props;

    return (
      <section className="container">
        <div className="col">
          <Breadcrumbs />
        </div>

         <CheckObligation field="dadosBancarios_Banco">
          {(validacoes) =>
            <div className="col-50">
                <Typeaheader
                    dataSource={typeaheaderBancoList}
                    fieldValue="CodigoBanco"
                    fieldText="Nome"
                    onChange={handleChangeDadosBanco}
                    value={dadosBancarios_Banco}
                    required={validacoes.obrigatorio}
                    name="dadosBancarios_Banco"
                    loading={loadingDadosBancarios}
                    label="Banco"
                    returnObject={this.createRefFields}
                  />
            </div>}
        </CheckObligation>

        <CheckObligation field="dadosBancarios_TipoConta">
          {(validacoes) =>
            <div className="col-50 banco">
              <Dropdown
                value={dadosBancarios_TipoConta}
                onChange={(event) => {
                    changeDadosIniciaisDadosBancariosValueForm("dadosBancarios_TipoConta", "");
                    handleChangeDadosTipoConta(event);
                }}
                dataSource={dropdownTipoContaList}
                required={validacoes.obrigatorio}
                loading={loadingTipoConta}
                name="dadosBancarios_TipoConta"
                returnObject={this.createRefFields}
                label="Tipo de conta" />
            </div>}
        </CheckObligation>

        <CheckObligation field="dadosBancarios_Agencia">
          {(validacoes) =>
            <div className="col-50">
             <Field
                type="text"
                placeholder="Digite a sua agência"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Agência"
                name="dadosBancarios_Agencia"
                mask={'99999999999999999999'}
                minlength={3}
                maxlength={100}
                value={dadosBancarios_Agencia}
                onChange={changeDadosIniciaisDadosBancariosValueForm}
                 />
            </div>}
        </CheckObligation>

        <CheckObligation field="dadosBancarios_Conta">
          {(validacoes) =>
            <div className="col-50">
             <Field
                type="text"
                placeholder="Digite a sua conta"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Conta"
                name="dadosBancarios_Conta"
                minlength={3}
                maxlength={10}
                value={dadosBancarios_Conta}
                onChange={(event, value) => {
                  let v = value.replace("-", "");
                  if (v.length > 1) {
                    let digit = v[v.length-1];
                    v = v.substring(0, v.length - 1) + "-" + digit;
                  }
                  changeDadosIniciaisDadosBancariosValueForm("dadosBancarios_Conta", v);
              }}
                 />
            </div>}
        </CheckObligation>        
        <div className="col">
          <NavigationButtons history={this.props.history} validateFields={this.validateFields} />
        </div>
      </section>
    );
  }


  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  validateFields = async () => {
    let list = []
    let countMounted = 0

    return new Promise(resolve => {
      if (Object.keys(this.formFields).length === 0) {
        resolve([])
      }

      for (let key in this.formFields) {
        if (this.formFields[key]._isMounted) {
          countMounted++
          this.formFields[key].validate(this.formFields[key].input)

            // eslint-disable-next-line no-loop-func
            .then(r => {
              list.push({ name: this.formFields[key].props.name, valid: r })

              if (countMounted === list.length) {
                resolve(list)
              }
            })
        }
      }
    })
  }
}

export default DadosBancarios;
